module.exports = __webpack_public_path__ + "img/back4.98c10ec6.png";